(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paginaproductov2"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('sb-product')) return;

  var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class SbProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var dataEl = this.querySelector('[data-sbp-data]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('sb-product: JSON inválido', e); return; }
      this.t = this.data.texts;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.form = this.querySelector('[data-sbp-form]');
      this.idInput = this.form ? this.form.querySelector('[data-variant-id]') : null;
      this.qtyInput = this.querySelector('[data-qty]');
      this.atc = this.querySelector('[data-atc]');
      this.buyNow = this.querySelector('[data-buy-now]');
      this.cartTotal = 0;
      var id = this.idInput ? Number(this.idInput.value) : null;
      this.variant = this.data.variants.find(function (v) { return v.id === id; }) || this.data.variants[0];

      this.initGallery();
      this.initPicker();
      this.initQty();
      this.initForm();
      this.initPair();
      this.initSticky();
      this.initLightbox();
      this.updateDelivery();
      this.updateShipping();
      this.fetchCart();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    /* ---------------- Utilidades ---------------- */
    money(cents) {
      var fmt = this.data.moneyFormat || ('$' + '{' + '{amount}' + '}');
      function val(c, dec, ts, ds) {
        var n = (c / 100).toFixed(dec).split('.');
        var i = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
        return n[1] ? i + ds + n[1] : i;
      }
      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        switch (k) {
          case 'amount_no_decimals': return val(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return val(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return val(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return val(cents, 2, "'", '.');
          case 'amount_with_space_separator': return val(cents, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return val(cents, 0, ' ', ',');
          default: return val(cents, 2, ',', '.');
        }
      });
      out = out.replace(/<[^>]*>/g, '');
      if (this.data.hideDecimals) out = out.replace(/([.,])00(?!\d)/, '');
      return out;
    }

    qty() {
      return Math.max(1, parseInt(this.qtyInput ? this.qtyInput.value : '1', 10) || 1);
    }

    msg(text, type) {
      var el = this.querySelector('[data-msg]');
      if (!el) return;
      el.textContent = text || '';
      el.classList.toggle('is-error', type === 'error');
      el.classList.toggle('is-ok', type === 'ok');
      clearTimeout(this._msgT);
      if (text && type === 'ok') this._msgT = setTimeout(function () { el.textContent = ''; }, 4000);
    }

    openDialog(d) {
      if (!d) return;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      document.documentElement.classList.add('sbp-lock');
    }

    closeDialog(d) {
      if (!d) return;
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      document.documentElement.classList.remove('sbp-lock');
    }

    bindDialog(d) {
      var self = this;
      if (!d) return;
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-dialog-close]')) self.closeDialog(d);
      });
      d.addEventListener('close', function () { document.documentElement.classList.remove('sbp-lock'); });
    }

    /* ---------------- Galería ---------------- */
    initGallery() {
      var self = this;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.goTo(i); }); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.goTo(i); }); });
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
      var raf;
      this.track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = self.track.clientWidth || 1;
          self.setActive(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      });
    }

    goTo(i, instant) {
      var n = this.slides ? this.slides.length : 0;
      if (!n) return;
      i = ((i % n) + n) % n;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      this.setActive(i);
    }

    setActive(i) {
      if (!this.slides || i === this._lastActive) return;
      this._lastActive = i;
      this.index = i;
      this.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      this.slides.forEach(function (s, k) {
        if (k === i) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
      var thumb = this.thumbs[i];
      var wrap = this.querySelector('[data-thumbs]');
      if (thumb && wrap) {
        var vertical = wrap.scrollHeight > wrap.clientHeight + 2 && getComputedStyle(wrap).flexDirection === 'column';
        if (vertical) wrap.scrollTo({ top: thumb.offsetTop - wrap.clientHeight / 2 + thumb.clientHeight / 2, behavior: 'smooth' });
        else wrap.scrollTo({ left: thumb.offsetLeft - wrap.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
      }
    }

    /* ---------------- Variantes ---------------- */
    initPicker() {
      var self = this;
      this.fieldsets = Array.prototype.slice.call(this.querySelectorAll('[data-option-index]'));
      var picker = this.querySelector('[data-picker]');
      if (!picker) return;
      picker.addEventListener('change', function (e) {
        if (e.target.matches('[data-option-value]')) self.onOptionChange();
      });
      this.updateAvailability();
    }

    selected() {
      return this.fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    onOptionChange() {
      var sel = this.selected();
      this.fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        fs.querySelectorAll('.sbp-swatch').forEach(function (l) {
          l.classList.toggle('is-selected', l.contains(c));
        });
        var lab = fs.querySelector('[data-option-selected]');
        if (lab && c) lab.textContent = c.dataset.label || c.value;
      });
      var v = this.data.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      this.setVariant(v || null);
      this.updateAvailability();
    }

    updateAvailability() {
      var variants = this.data.variants;
      var sel = this.selected();
      this.fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('[data-option-value]').forEach(function (input) {
          var matches = variants.filter(function (v) {
            return v.options[i] === input.value && v.options.every(function (o, j) { return j === i || sel[j] == null || o === sel[j]; });
          });
          var available = matches.some(function (v) { return v.available; });
          var label = input.closest('.sbp-swatch');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    setVariant(v) {
      var self = this;
      this.variant = v;
      var t = this.t;
      var atcTexts = this.querySelectorAll('[data-atc-text]');
      var buttons = [this.atc, this.buyNow, this.querySelector('[data-sticky-atc]')];
      var pairBtn = this.querySelector('[data-pair-add]');

      if (!v) {
        atcTexts.forEach(function (el) { el.textContent = t.unavailable; });
        buttons.forEach(function (b) { if (b) b.disabled = true; });
        if (pairBtn) pairBtn.disabled = true;
        this.updateStock(null);
        return;
      }

      if (this.idInput) this.idInput.value = v.id;
      if (this.data.updateUrl) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }

      this.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = self.money(v.price); });
      var cmp = this.querySelector('[data-compare]');
      if (cmp) {
        cmp.hidden = !(v.compare > v.price);
        cmp.textContent = v.compare > v.price ? self.money(v.compare) : '';
      }

      atcTexts.forEach(function (el) { el.textContent = v.available ? t.atc : t.soldOut; });
      buttons.forEach(function (b) { if (b) b.disabled = !v.available; });
      if (pairBtn) pairBtn.disabled = !v.available;
      this.updateStock(v);

      if (v.media && this.slides) {
        var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId == v.media; });
        if (idx > -1) this.goTo(idx);
      }

      var stickyVar = this.querySelector('[data-sticky-variant]');
      if (stickyVar) stickyVar.textContent = v.title;
      if (v.image) {
        this.swapImg(this.querySelector('[data-sticky-img]'), v.image, '');
        this.swapImg(this.querySelector('[data-pair-current-img]'), v.image, v.title);
      }
      var pairLabel = this.querySelector('[data-pair-current-label]');
      if (pairLabel) {
        var base = pairLabel.dataset.base || pairLabel.textContent.split(' · ')[0];
        pairLabel.dataset.base = base;
        pairLabel.textContent = this.data.variants.length > 1 ? base + ' · ' + v.title : base;
      }

      this.updateShipping();
      this.updatePairTotal();
      this.dispatchEvent(new CustomEvent('sbp:variant-change', { bubbles: true, detail: { variant: v } }));
    }

    swapImg(wrap, src, alt) {
      if (!wrap || !src) return;
      var img = wrap.querySelector('img');
      if (!img) { img = document.createElement('img'); wrap.appendChild(img); }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.alt = alt || '';
    }

    updateStock(v) {
      var t = this.t;
      var badge = this.querySelector('[data-stock-badge]');
      var line = this.querySelector('[data-stock-line]');
      var low = v && v.available && v.tracked === 'shopify' && v.policy === 'deny' && v.qty > 0 && v.qty <= this.data.lowStock;
      if (badge) {
        badge.classList.toggle('is-out', !v || !v.available);
        badge.classList.toggle('is-low', !!low);
        badge.textContent = !v ? t.unavailable : !v.available ? t.badgeOut : low ? t.badgeLow.replace('[n]', v.qty) : t.badgeIn;
      }
      if (line) line.textContent = v && v.available ? t.stockIn : t.stockOut;
    }

    /* ---------------- Envío y entrega ---------------- */
    fetchCart() {
      var self = this;
      if (!this.data.threshold) return;
      fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.cartTotal = c.total_price || 0; self.updateShipping(); })
        .catch(function () {});
    }

    updateShipping() {
      var el = this.querySelector('[data-ship-text]');
      if (!el) return;
      var th = this.data.threshold;
      var price = this.variant ? this.variant.price * this.qty() : 0;
      el.textContent = th > 0 && this.cartTotal + price >= th ? this.t.shipFree : this.t.ship;
    }

    updateDelivery() {
      var el = this.querySelector('[data-delivery]');
      if (!el || !this.t.delivery) return;
      var skip = this.data.skipWeekends;
      function add(n) {
        var d = new Date();
        var added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
        }
        return d;
      }
      function f(d) { return '<strong>' + DAYS[d.getDay()] + ' ' + d.getDate() + ' de ' + MONTHS[d.getMonth()] + '</strong>'; }
      var min = Number(this.data.delMin) || 0;
      var max = Math.max(min, Number(this.data.delMax) || 0);
      el.innerHTML = esc(this.t.delivery).replace('[inicio]', f(add(min))).replace('[fin]', f(add(max)));
    }

    /* ---------------- Cantidad ---------------- */
    initQty() {
      var self = this;
      var minus = this.querySelector('[data-qty-minus]');
      var plus = this.querySelector('[data-qty-plus]');
      if (!this.qtyInput) return;
      if (minus) minus.addEventListener('click', function () { self.qtyInput.value = Math.max(1, self.qty() - 1); self.updateShipping(); });
      if (plus) plus.addEventListener('click', function () { self.qtyInput.value = self.qty() + 1; self.updateShipping(); });
      this.qtyInput.addEventListener('change', function () { self.qtyInput.value = self.qty(); self.updateShipping(); });
    }

    /* ---------------- Agregar al carrito ---------------- */
    initForm() {
      var self = this;
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!self.variant || !self.variant.available) return;
          self.addToCart([{ id: self.variant.id, quantity: self.qty() }], 'atc', self.atc);
        });
      }
      if (this.buyNow) {
        this.buyNow.addEventListener('click', function () {
          if (!self.variant || !self.variant.available) return;
          self.addToCart([{ id: self.variant.id, quantity: self.qty() }], 'buynow', self.buyNow);
        });
      }
    }

    addToCart(items, mode, btn) {
      var self = this;
      var after = mode === 'buynow' ? 'checkout' : this.data.afterAdd;
      var drawer = document.querySelector('cart-drawer');
      var notif = document.querySelector('cart-notification');
      var target = after === 'auto' ? (drawer || notif) : null;
      var body = { items: items };
      if (target && typeof target.getSectionsToRender === 'function') {
        body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      this.msg('');

      fetch(this.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          var data = res.data;
          if (!res.ok || data.status) throw new Error(data.description || data.message || self.t.error);

          var added = (data.items || [data]).reduce(function (sum, it) { return sum + (it.final_line_price || it.line_price || 0); }, 0);
          self.cartTotal += added;
          self.updateShipping();

          if (after === 'checkout') { window.location.href = self.root + 'checkout'; return; }
          if (after === 'cart') { window.location.href = self.root + 'cart'; return; }

          if (after === 'auto') {
            if (target && typeof target.renderContents === 'function' && data.sections) {
              var first = (data.items && data.items[0]) || data;
              var state = Object.assign({}, first, { sections: data.sections });
              if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              target.renderContents(state);
              if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sb-product', productVariantId: first.variant_id, cartData: data });
              }
            } else {
              window.location.href = self.root + 'cart';
              return;
            }
          } else {
            self.notifyTheme(data);
            self.msg(self.t.added, 'ok');
          }
        })
        .catch(function (err) {
          self.msg(err && err.message ? err.message : self.t.error, 'error');
        })
        .finally(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.disabled = !self.variant || !self.variant.available;
          }
        });
    }

    notifyTheme(data) {
      ['cart:refresh', 'cart:updated', 'cart:build', 'cart:open', 'theme:cart:refresh', 'ajaxProduct:added'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: data }));
      });
      fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .js-cart-count, .cart-item-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    /* ---------------- Completa tu par ---------------- */
    initPair() {
      var self = this;
      this.pair = this.querySelector('[data-pair]');
      if (!this.pair) return;
      this.pairDialog = this.querySelector('[data-pair-dialog]');
      this.pairBtn = this.pair.querySelector('[data-pair-add]');
      this.pairChoice = null;
      this.bindDialog(this.pairDialog);

      this.pair.querySelector('[data-pair-open]').addEventListener('click', function () { self.openDialog(self.pairDialog); });
      this.pairBtn.addEventListener('click', function () {
        if (!self.pairChoice) { self.openDialog(self.pairDialog); return; }
        if (!self.variant || !self.variant.available) return;
        self.addToCart([{ id: self.variant.id, quantity: 1 }, { id: self.pairChoice.id, quantity: 1 }], 'pair', self.pairBtn);
      });

      if (!this.pairDialog) return;
      this.pairDialog.addEventListener('click', function (e) {
        var choose = e.target.closest('[data-pick-choose]');
        if (choose) self.choosePair(choose.closest('[data-pick]'));
      });
      this.pairDialog.addEventListener('change', function (e) {
        if (!e.target.matches('select[data-pick-variant]')) return;
        var opt = e.target.selectedOptions[0];
        var card = e.target.closest('[data-pick]');
        var img = card.querySelector('.sbp-pick__img img');
        if (img && opt && opt.dataset.image) { img.removeAttribute('srcset'); img.src = opt.dataset.image; }
        var price = card.querySelector('.sbp-pick__price');
        if (price && opt) price.textContent = self.money(Number(opt.dataset.vprice));
      });
    }

    choosePair(card) {
      if (!card) return;
      var el = card.querySelector('[data-pick-variant]');
      var src = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
      if (!src) return;
      this.pairChoice = {
        id: Number(src.value),
        price: Number(src.dataset.vprice),
        image: src.dataset.image,
        title: card.dataset.title,
        label: src.dataset.label
      };
      var c = this.pairChoice;
      var pick = this.pair.querySelector('[data-pair-open]');
      var imgWrap = this.pair.querySelector('[data-pair-pick-img]');
      var label = this.pair.querySelector('[data-pair-pick-label]');
      pick.classList.add('is-chosen');
      this.pair.querySelector('[data-pair-empty]').hidden = true;
      this.pair.querySelector('[data-pair-change]').hidden = false;
      imgWrap.hidden = false;
      this.swapImg(imgWrap, c.image, c.title);
      label.hidden = false;
      label.textContent = c.label ? c.title + ' · ' + c.label : c.title;
      this.pairBtn.textContent = this.t.pairBtn;
      this.updatePairTotal();
      this.closeDialog(this.pairDialog);
    }

    updatePairTotal() {
      var el = this.querySelector('[data-pair-total]');
      if (!el) return;
      if (!this.pairChoice || !this.variant) { el.hidden = true; return; }
      el.hidden = false;
      el.textContent = this.t.pairTotal.replace('[total]', this.money(this.variant.price + this.pairChoice.price));
    }

    /* ---------------- Barra fija ---------------- */
    initSticky() {
      var self = this;
      this.sticky = this.querySelector('[data-sticky]');
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      this._io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = self.sticky.querySelector('[data-sticky-atc]');
        if (b) b.tabIndex = show ? 0 : -1;
      });
      this._io.observe(this.atc);
      var btn = this.sticky.querySelector('[data-sticky-atc]');
      if (btn) btn.addEventListener('click', function () {
        if (!self.variant || !self.variant.available) return;
        self.addToCart([{ id: self.variant.id, quantity: self.qty() }], 'atc', btn);
      });
    }

    /* ---------------- Lightbox ---------------- */
    initLightbox() {
      var self = this;
      var lb = this.querySelector('[data-lightbox]');
      if (!lb) return;
      this.bindDialog(lb);
      this.querySelectorAll('[data-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          self.openDialog(lb);
          var item = lb.querySelector('[data-lb-item="' + b.dataset.zoom + '"]');
          if (item) requestAnimationFrame(function () { item.scrollIntoView({ block: 'start' }); });
        });
      });
    }
  }

  customElements.define('sb-product', SbProduct);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
